import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SortDirection} from '@app/shared';

@Component({
  selector: 'app-st-th-sort',
  standalone: false,
  templateUrl: './st-th-sort.component.html',
  styleUrl: './st-th-sort.component.less'
})
export class StThSortComponent {

  @Input() sortDirection: SortDirection = null;
  @Output() sortEvent = new EventEmitter<void>();

  emitSortEvent(): void {
    this.sortEvent.emit();
  }

}
